import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { RecoilRoot } from 'recoil';
import queryString from 'query-string';
import { localStorage as storageKeys } from 'utils/constants';
import App from './App';
import reportWebVitals from './reportWebVitals';

import 'bootstrap/dist/css/bootstrap.css';
import 'react-toastify/dist/ReactToastify.min.css';
import 'venobox/dist/venobox.min.css';

import './styles/main.scss';

// Pin the entry token BEFORE the first render so no request can race it.
// sessionStorage is per browser tab: pinning the token here keeps two assessments
// opened in two tabs independent, instead of the last one opened overwriting the
// shared localStorage token for every tab (ticket 47022817462).
const { token } = queryString.parse(window.location.search);
if (typeof token === 'string' && token) {
  window.sessionStorage.setItem(storageKeys.JWT_TOKEN, token);
  window.localStorage.setItem(storageKeys.JWT_TOKEN, token);
}

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
export const history = createBrowserHistory({ basename: baseUrl });

history.listen((location) => {
  const { hash } = location;
  if (hash) {
    // Push onto callback queue so it runs after the DOM is updated,
    // this is required when navigating from a different page so that
    // the element is rendered on the page before trying to getElementById.
    setTimeout(
      () => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      },
      0,
    );
  }
});

ReactDOM.render(
  <Router history={history}>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </Router>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
